<div
  [ngClass]="{
    'relative border border-l-[5px]': true,
    'border-info': variant === 'info',
    'bg-infoLight': variant === 'info',
    'text-infoDark': variant === 'info',
    'border-warning': variant === 'warning',
    'bg-warningLight': variant === 'warning',
    'text-warningDark': variant === 'warning',
    'border-error': variant === 'error',
    'bg-errorLight': variant === 'error',
    'text-errorDark': variant === 'error',
    className : true
  }"
>
  <div class="grid grid-cols-[min-content_1fr_min-content]">
    <!-- Icon -->
    <div
      class="pl-4 pr-1.5 pt-4"
      [ngClass]="{
        'text-info': variant === 'info',
        'text-warning': variant === 'warning',
        'text-error': variant === 'error'
      }"
    >
      @switch (variant) { @case ('info'){
      <pax-icon
        name="info_circle"
        containerClass="block h-4.5 w-4.5"
      ></pax-icon>
      } @case ('warning'){
      <pax-icon name="exclamation_triangle" containerClass="block h-5 w-5">
      </pax-icon>
      } @case ('error'){
      <pax-icon name="exclamation_triangle" containerClass="block h-5 w-5">
      </pax-icon>
      }}
    </div>
    <!-- Content -->
    <div class="px-1.5 py-3">
      @if (title) {
      <h4 class="mb-1.5 text-lg font-bold">{{title}}</h4>
      }
      <div class="text-base">
        <!-- No Markdown-->
        @if (content) { {{content}} }
        <!-- Markdown -->
        @if (markdown) {
        <!-- Unfortunately we have to redefine the styles for the markdown as the tag breaks the inheritance from its ancestor -->
        <pax-markdown
          [ngClass]="{
              'prose-infoDark': variant === 'info',
              'prose-warningDark': variant === 'warning',
              'prose-errorDark': variant === 'error'
              }"
          >{{ markdown }}</pax-markdown
        >
        } @if (markdownAsData) {
        <!-- This approach should replace the "markdown" one above as it is not working with Signals. To not break anything I leave it as is for now and declare a new input variable -->
        <pax-markdown
          [ngClass]="{
              'prose-infoDark': variant === 'info',
              'prose-warningDark': variant === 'warning',
              'prose-errorDark': variant === 'error'
              }"
          [data]="markdownAsData"
        ></pax-markdown>
        }
      </div>
    </div>
    <!-- Close Button -->
    <div class="py-2.5 pr-1.5">
      <button
        type="button"
        class="cursor-pointer"
        (click)="closeDialog.emit()"
        [style.visibility]=" showCloseButton ? 'visible' : 'hidden'"
      >
        <span class="sr-only" i18n="Close alert dialog">Schliessen</span>
        <pax-icon name="x" containerClass="w-6 h-6"></pax-icon>
      </button>
    </div>
  </div>
</div>
